/**
 * Idioma escolhido em Conta > Preferências (decisão 195).
 *
 * A escolha fica no servidor (`preferences.language`) e numa cópia neste navegador, para a
 * abertura já sair no idioma certo, sem piscar no idioma da marca. Sem escolha, vale o idioma da
 * marca, como antes.
 */
import { changeLanguage } from '../i18n';
import { SUPPORTED_LANGS, type SupportedLang } from '../config/constants';

const KEY = 'lm.language';

export function isPanelLanguage(value: unknown): value is SupportedLang {
  return typeof value === 'string' && (SUPPORTED_LANGS as readonly string[]).includes(value);
}

/** Idioma guardado neste navegador, ou null. */
export function cachedLanguage(): SupportedLang | null {
  try {
    const saved = localStorage.getItem(KEY);
    return isPanelLanguage(saved) ? saved : null;
  } catch {
    return null;
  }
}

export function rememberLanguage(language: SupportedLang): void {
  try {
    localStorage.setItem(KEY, language);
  } catch {
    /* sem storage: vale só nesta aba */
  }
}

/** Troca o idioma do painel na hora e guarda a escolha neste navegador. */
export async function applyLanguage(language: SupportedLang): Promise<void> {
  rememberLanguage(language);
  await changeLanguage(language);
}
